/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, Fragment, useMemo, useCallback, useState, useEffect } from "react";

// antd:
// import { LoadingOutlined } from "@ant-design/icons";
import { Form, Image } from "antd";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

// import DivE from "../react/DivE.tsx";
// Redux-hooks:
import { useAppSelector, useAppDispatch } from "../../libs/redux-hooks.ts";
// Reducers:
import { getLng, getDict, getTheme, getAppState, changeAppState, getUser, getSafePtr } from "../../libs/reducer.ts";
// My functions
import fnc from "../../libs/fnc.ts";
// Types:
import type {TuniversalElementProps} from "../../types/Iuigen.d.ts";
import type {Tpermissions} from "../../types/easyTypes.ts";

// const { Option } = Select;
const { rz } = window;

// eslint-disable-next-line max-len
const fallbackDefault = "data:image/png;base64,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";

type Timage = {
  preview?:boolean | {[key:string]:any},
  width?:number | string,
  height?:number | string,
  movable?:boolean,
  imagegroup?:boolean
};

const RZimage:FC<TuniversalElementProps> = ({attributes, children}) => {
  RZimage.displayName = "Image";
  const dispatch = useAppDispatch();
  const user = useAppSelector(getUser);
  const dct = useAppSelector(getDict);
  const lng = useAppSelector(getLng);
  const theme = useAppSelector(getTheme);
  const safe = useAppSelector(getSafePtr);
  const rlng = (lng === "en" ? "ru" : "en");

  const {rootAttributes, key, fullPath, type, content} = attributes; // onClick, onChange, onRightClick, onHover, onLoad
  const appState = useAppSelector(getAppState(rootAttributes.key));
  const elState = appState[fullPath];
  const {icon, iconClass, iconColor, color, backgroundColor} = elState.attributes;
  const rootNamespace = useMemo(() => (window[rootAttributes.key || rz.strMakeID(24)]), [rootAttributes.key]);

  const isParentForm = useMemo(() => {
    const parentPath = rz.strParentFolderName(fullPath || ""), parentState = appState[parentPath];
    return Boolean(parentState.name === "form");
  }, [appState, fullPath]);

  const permissions = useMemo<Tpermissions>(() => (fnc.checkPermissions(user, attributes)), [user, attributes]);

  const imgType = useMemo<Timage>(() => {
    const typ:Timage = {preview: false, movable: false};
    (type || "").replace((/(\s+|_|\|)/igm), " ").split(" ").forEach((tt) => {
      if (tt === "small") { typ.width = 120 }
      else if (~["medium", "middle"].indexOf(tt)) { typ.width = 260 }
      else if (~["imagegroup", "group"].indexOf(tt)) { typ.imagegroup = true }
      else if (tt === "large") { typ.width = 480 }
      else if (tt === "preview") { typ.preview = true }
      else if (tt === "movable") { typ.movable = true }
    });

    if (attributes?.preview) {
      if (attributes.preview.startsWith("{") && attributes.preview.endsWith("}")) {
        const jsnb = (rz.strReplaceAll(attributes.preview, "'", "\"")).trim(); let jsn; try { jsn = JSON.parse(jsnb) } catch (err) { console.log(err) }
        if (jsn) { typ.preview = jsn }
      }
      else { typ.preview = (attributes.preview === "true") }
    }
    if (attributes?.movable) { typ.movable = (attributes.movable === "true") }
    if (attributes?.width) { typ.width = (rz.isNumeric(attributes.width) ? Number(attributes.width) : attributes.width) }
    if (attributes?.height) { typ.height = (rz.isNumeric(attributes.height) ? Number(attributes.height) : attributes.height) }
    if (attributes?.imagegroup) { typ.imagegroup = (attributes.imagegroup === "true") }
    return typ;
  }, [type, attributes]);

  const clsu = useMemo<Array<string>>(() => {
    const userClss = rz.objClone(elState?.userClass || []);
    // if ((elState?.disabled || permissions.disabled === true) && !~userClss.indexOf("uk-disabled")) { userClss.push("uk-disabled") }
    return userClss;
  }, [elState?.userClass]);

  const styl = useMemo<CSS.Properties>(() => {
    const est = {...elState.userStyle};
    if ((elState?.visible === false || permissions.visible === false) && est.display !== "none") { est.display = "none" }
    else if ((elState?.visible === true && permissions.visible !== false) && est.display === "none") { est.display = undefined }
    let clr:string; const allc = (color || "").split("|"); if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    if (!est?.color && clr) { est.color = clr }
    let bclr:string; const allb = (backgroundColor || "").split("|"); if (allb.length > 1) { bclr = (theme === "dark" ? allb[1] : allb[0]) } else { bclr = allb[0] }
    if (!est?.backgroundColor && bclr) { est.backgroundColor = bclr }
    return est;
  }, [elState?.userStyle, elState?.visible, color, backgroundColor, theme, permissions]);

  const items = useMemo(() => {
    let options:Array<string> = [];
    if (elState?.items) {
      if (rz.isArray(elState.items)) { options = elState.items }
      else if (rz.isObject(elState.items) && elState.items.items && rz.isArray(elState.items.items)) { options = elState.items.items }
    }
    return options;
  }, [elState?.items]);

  const onChange = useCallback((current, prev) => {
    if (fnc.config?.isDev) console.log({action: "<Image.Preview key='" + key + "'> -> onChange()", current, prev, value: items[current], items});
    dispatch(changeAppState({appkey: rootAttributes.key, fullPath, newState: {...elState, value: items[current]}}));
    if (rootNamespace && (attributes.onChange || attributes.onchange) && rootNamespace[attributes.onChange || attributes.onchange]) {
      const clientFNC = rootNamespace[attributes.onChange || attributes.onchange];
      if (rz.isPromise(clientFNC)) {
        clientFNC({appkey: rootAttributes.key, attributes, key, user, lng, dct, value: items[current], items, current, safe}).then((ret) => {
          if (rz.isUndefinedOrNull(ret)) { return }
          if (ret?.err) { console.log(ret.err) }
          if (ret && ret?.state?.fullPath && ret?.state?.newState) {
            dispatch(changeAppState({appkey: rootAttributes.key, fullPath: ret.state.fullPath, newState: ret.state.newState}));
          }
        });
      }
      else if (rz.isFunction(clientFNC)) {
        const ret = clientFNC({appkey: rootAttributes.key, attributes, key, user, lng, dct, value: items[current], items, current, safe}); if (rz.isUndefinedOrNull(ret)) { return }
        if (ret?.err) { console.log(ret.err) }
        if (ret && ret?.state?.fullPath && ret?.state?.newState) {
          dispatch(changeAppState({appkey: rootAttributes.key, fullPath: ret.state.fullPath, newState: ret.state.newState}));
        }
      }
    }
  }, [key, items, dispatch, rootAttributes.key, fullPath, elState, rootNamespace, attributes, user, lng, dct, safe]);

  const preview = useMemo<boolean | {[key:string]:any}>(() => {
    let prw:boolean | {[key:string]:any} = false;
    if (imgType.preview && (rz.isBoolean(imgType.preview) || rz.isObject(imgType.preview))) { prw = imgType.preview }
    if (rz.isBoolean(imgType.movable)) {
      if (prw === true) { prw = {movable: imgType.movable} }
      else if (rz.isObject(prw)) { (prw as {[key:string]:any}).movable = imgType.movable }
    }
    if (items && items.length) {
      if (prw === true) { prw = {onChange} }
      else if (rz.isObject(prw)) { (prw as {[key:string]:any}).onChange = onChange }
    }
    return prw;
  }, [imgType.movable, imgType.preview, items, onChange]);

  // eslint-disable-next-line react-hooks/exhaustive-deps, max-len
  const title = useMemo<string | undefined>(() => (elState.attributes["title_" + lng] || elState.attributes.title || elState.attributes["title_" + rlng] || attributes["title_" + lng] || attributes.title || attributes["title_" + rlng]), [elState.attributes, attributes, lng]);
  // eslint-disable-next-line max-len, react-hooks/exhaustive-deps
  const title2 = useMemo<string | undefined>(() => (elState?.attributes["title2_" + lng] || elState?.attributes.title2 || elState?.attributes["title2_" + rlng] || attributes["title2_" + lng] || attributes.title2 || attributes["title2_" + rlng]), [elState?.attributes, attributes, lng]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const tooltip = useMemo<string | undefined>(() => (elState.attributes["tooltip_" + lng] || elState.attributes.tooltip || elState.attributes["tooltip_" + rlng]), [elState.attributes, lng]);
  // eslint-disable-next-line react-hooks/exhaustive-deps, max-len
  const alt = useMemo<string | undefined>(() => (elState?.attributes["alt_" + lng] || elState?.attributes.alt || elState?.attributes["alt_" + rlng] || attributes["alt_" + lng] || attributes.alt || attributes["alt_" + rlng]), [elState?.attributes, attributes, lng]);

  const wrapperForm = useCallback((mainComponent:React.ReactNode) => {
    if (isParentForm) {
      const frmItemProps:{[key:string]:any} = {
        key: key + "-formitem", label: (<span className="rz-txt-std">{title2}</span>), className: "rz-width-expand",
        style: ((elState?.visible === false || permissions.visible === false) ? {display: "none"} : undefined)
      };
      // eslint-disable-next-line max-len
      return (
        <Form.Item {...frmItemProps}>
          {mainComponent}
        </Form.Item>
      )
    }
    return mainComponent;
  }, [isParentForm, title2, key, elState?.visible, permissions.visible]);

  if (!imgType.imagegroup) {
    return wrapperForm(
      <Image
        key={key} style={styl} className={clsu.join(" ")} uk-tooltip={tooltip}
        // value/src/value из attributes поддержаны как равноправные источники, чтобы XML-демо и Redux state работали одинаково; alt передаем в Ant Image для доступности.
        src={elState.value || attributes?.src || attributes?.value || ""}
        alt={alt}
        fallback={elState?.attributes.fallback || attributes.fallback || fallbackDefault}
        width={imgType.width} height={imgType.height}
        preview={preview}
        placeholder={children}
      />
    );
  }

  if (items && items.length) {
    // ImageGroup
    return wrapperForm(
      <Image.PreviewGroup key={"preview-" + key} items={items} preview={preview} >
        <Image
          key={key} id={key} style={styl} className={clsu.join(" ")} uk-tooltip={tooltip}
          // В группе первый элемент items становится стартовой картинкой, если value еще не записан в state.
          src={elState.value || attributes?.src || attributes?.value || items[0]}
          alt={alt}
          fallback={elState?.attributes.fallback || attributes.fallback || fallbackDefault}
          width={imgType.width} height={imgType.height}
          preview={preview}
          placeholder={children}
        />
      </Image.PreviewGroup>
    );
  }

  return wrapperForm(
    <Image
      key={key} style={styl} className={clsu.join(" ")} uk-tooltip={tooltip}
      src={elState.value || attributes?.src || attributes?.value || ""} alt={alt}
      fallback={elState?.attributes.fallback || attributes.fallback || fallbackDefault}
      width={imgType.width} height={imgType.height}
      preview={preview}
      placeholder={children}
    />
  );
}

export default RZimage;
/* eslint-enable @typescript-eslint/no-unused-vars */
